export const handleAsync =
  (fn: (e: React.BaseSyntheticEvent) => Promise<any>) =>
  (e: React.BaseSyntheticEvent) => {
    fn(e).catch(() => {})
  }
